import { ReduceStore } from 'flux/utils';
import Dispatcher from 'dispatcher/appDispatcher';
import ActionType from '../../../../../constants/actionType';
import { get } from 'lodash';

class ReportsListStore extends ReduceStore {
  
  get reportCategories() { return get(this.getState(), 'categories', []); }
  
  get currentCategoryReports() { return get(this.getState(), 'currentCategoryReports', []);  }
  
  get allReports() { return get(this.getState(), 'allReports', null);  }
  
  constructor() {
    super(Dispatcher);
  }
  
  getInitialState() {
    return {
      categories: [],
      currentCategoryReports: [],
      allReports: null
    }
  }
  
  reduce(state, action) {
    switch (action.actionType) {
      
      case ActionType.BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_REPORT_CATEGORIES:
        return {
          ...state,
          categories: action.categories
        };
        
      case ActionType.BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_REPORTS_LIST_BY_CATEGORY:
        return {
          ...state,
          currentCategoryReports: get(action.reports, 'list', [])
        };
  
      case ActionType.BUILD_A_PROFILE_MODULE_REPORTS_LIST_PAGE_GET_GLOBAL_REPORTS_LIST:
        return {
          ...state,
          allReports: action.reports
        };
      
      default:
        return state;
    }
  }
  
}

export const reportsListStore = new ReportsListStore();
